import { type UseQueryResult, useQuery } from 'react-query';
import {
  VestingTemplateService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_VestingTemplateForListDto,
} from '@wealthlane/api-services/wealthlane-award-service';
import { type TableParamsType } from '../../types/common';
import { excludeDecimalFields } from '../../utils/apiDecimalConfig';

const useGetVestingTemplateList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
  // vestingTypeIds?: string[]
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_VestingTemplateForListDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount, vestingTypeIds, _force } = tableInfo;
  const vestingTemplateList = useQuery(
    ['getVestingTemplateList', filter, sorting, skipCount, maxResultCount, vestingTypeIds, _force],
    async () => {
      return await handleRequest(
        excludeDecimalFields(
          VestingTemplateService.getApiAwardApiAppVestingTemplateVestingTemplateList(
            vestingTypeIds,
            filter,
            sorting,
            skipCount,
            maxResultCount
          ),
          ['items[].amountOneInPercentage']
        )
      );
    }
  );

  return vestingTemplateList;
};

export default useGetVestingTemplateList;
